module.exports = __webpack_public_path__ + "static/img/rank_30.d749652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_30.png
// module id = BK0t
// module chunks = 0